import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Technology from './components/Technology';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home-faq';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Where is Elite Performance Lab located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Elite Performance Lab is located in Corsicana, TX — approximately 50 minutes south of Dallas."
          }
        },
        {
          "@type": "Question",
          "name": "What technology does Elite Performance Lab use?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We use ArmCare, Rapsodo, UpLift AI (motion capture), and NewtForce for data-driven biomechanics and performance tracking."
          }
        },
        {
          "@type": "Question",
          "name": "What programs does Elite Performance Lab offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer programs for all levels: 10u–13u Junior ($325/mo), 14u–16u Building Block ($425/mo), High School/College ($525/mo), College/Pro Prep Elite 30 ($650/mo), Summer ($1,500/mo), and Winter ($1,500/mo) programs, plus individual assessments and add-on services."
          }
        },
        {
          "@type": "Question",
          "name": "How many athletes has Elite Performance Lab developed?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Elite Performance Lab has developed 60+ college athletes and 8 professional players through its data-driven training methodology."
          }
        }
      ]
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-home-faq');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Programs />
      <Technology />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
